import type { AddressApi } from "../../api/AddressApi";
import type { AddressSearchParams } from "../../generated/dto/AddressSearchParams";
import type { AddressStaff } from "../../generated/dto/AddressStaff";
import type { AddressStaffSearchResult } from "../../generated/dto/AddressStaffSearchResult";
import type { CreateAddress } from "../../generated/dto/CreateAddress";
import type { DeleteAddressStaff } from "../../generated/dto/DeleteAddressStaff";
import type { UpdateAddress } from "../../generated/dto/UpdateAddress";
import type { PaginationResult } from "../../generated/dto/PaginationResult";

export class AddressFrontendService {
  constructor(private readonly api: AddressApi) {}
  async getAddressStaff(id: number): Promise<AddressStaff> {
    return this.api.getAddressStaff(id)
  }
  async createAddressStaff(source: CreateAddress): Promise<AddressStaff> {
    return this.api.createAddressStaff(source)
  }
  async updateAddressStaff(source: UpdateAddress): Promise<AddressStaff> {
    return this.api.updateAddressStaff(source)
  }
  async deleteAddressStaff(source: DeleteAddressStaff): Promise<void> {
    return this.api.deleteAddressStaff(source)
  }
  async searchAddressStaff(params: AddressSearchParams, page: number, perPage: number): Promise<PaginationResult<AddressStaffSearchResult>> {
    return this.api.searchAddressStaff(params, page, perPage)
  }
  async searchAddressStaffFull(params: AddressSearchParams, page: number, perPage: number): Promise<PaginationResult<AddressStaff>> {
    return this.api.searchAddressStaffFull(params, page, perPage)
  }
}
